<template>
  <UApp :locale="de">
    <DefaultLayout>
      <RouterView />
    </DefaultLayout>
  </UApp>
</template>

<script lang="ts" setup>
import { RouterView } from 'vue-router'
import { de } from '@nuxt/ui/locale'
import DefaultLayout from './layouts/DefaultLayout.vue'
</script>
